import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";
import { sweetAlert } from "../Common/Utills/Utills";

const NotificationHistory = () => {
  const [notificationData, setNotificationData] = useState([]);
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [selectedNotification, setSelectedNotification] = useState(null);

  const getData = async () => {
    let BASE_URL = SERVER_URL + `/api/compliance/all-document/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    setNotificationData(result.data);
  };

  useEffect(() => {
    getData();
  }, []);

  const openModal = (item) => {
    setSelectedNotification(item);
  };

  const deleteNotification = async (item) => {
    const message = "Do you want to delete this notification!";
    const result = await sweetAlert(message);
    if (!result.isConfirmed) {
      return;
    }

    const id = item.id;
    let BASE_URL =
      SERVER_URL + `/api/compliance/delete-notification/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "DELETE",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: id,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      toast.success(response.message);
      getData();
    } else {
      toast.error(response.message);
    }
  };
  const formatTimeDifference = (sentOn) => {
    const now = moment();
    const notificationTime = moment(sentOn);
    const diffMinutes = now.diff(notificationTime, "minutes");

    if (diffMinutes < 1) {
      return "just now";
    } else if (diffMinutes < 60) {
      return `${diffMinutes} minute${diffMinutes !== 1 ? "s" : ""} ago`;
    } else if (diffMinutes > 60 && diffMinutes < 1440) {
      const diffHours = Math.floor(diffMinutes / 60);
      return `${diffHours} hour${diffHours !== 1 ? "s" : ""} ago`;
    } else {
      const diffDays = Math.floor(diffMinutes / 1440);
      return `${diffDays} day${diffDays !== 1 ? "s" : ""} ago`;
    }
  };
  return (
    <>
      <div className="row">
        <div className="col-md-6 offset-3 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <p className="card-title text-center">Notification History</p>
              <div
                className="notification-content border"
                style={{ cursor: "pointer" }}
              >
                {notificationData &&
                  notificationData?.length > 0 &&
                  notificationData.map((item, index) => {
                    const formattedDate = moment(item.sent_on).format(
                      "DD-MM-YYYY"
                    );
                    const timeDifference = formatTimeDifference(item.sent_on);
                    return (
                      <>
                      <div className="notification-item align-items-center">
                        <div
                          className="d-flex"
                          key={index}
                          data-toggle="modal"
                          data-target="#NotificationModal"
                          onClick={() => openModal(item)}
                        >
                          <div className="notification-history-icon">
                            <i className="mdi mdi-information mx-0" />
                          </div>
                          <div
                            className="item-content ml-3"
                            // data-toggle="modal"
                            // data-target="#NotificationModal"
                            // onClick={() => openModal(item)}
                          >
                            <a className="font-weight-bold">{item.doc_name}</a>
                            <p className="font-weight-light small-text mb-0 text-muted"></p>
                            {formattedDate} ({timeDifference})
                          </div>
                        </div>
                          <button
                            className="close"
                            onClick={() => deleteNotification(item)}
                          >
                            <span className="mdi mdi-close"></span>
                          </button>

                      </div>
                      </>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="NotificationModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="basicModal"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header notification-modal-header">
              <h5 className="modal-title " id="myModalLabel">
                {selectedNotification && selectedNotification.doc_name} Renewal
                Notification
              </h5>
              {/* <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => setSelectedNotification(null)}>
                <span aria-hidden="true">&times;</span>
              </button> */}
            </div>
            <div className="modal-body notification-modal-body">
              <h5
                dangerouslySetInnerHTML={{
                  __html:
                    selectedNotification && selectedNotification.description,
                }}
              ></h5>
            </div>
            <div className="modal-logo">
              <img src="../../assets/images/kusum-logo.png" alt="" />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
                // onClick={() => closeNotification(selectedNotification)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotificationHistory;
